"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.getCoordinatesByColor=function(e,r,t){var o=e.hsb;return[o.s/100*r,(100-o.b)/100*t]};
